import React from 'react';

const BtnPlus = ({onClick, style}) => {
    const defaultStyle = {
        display: "flex",
        width: "30px",
        height: "30px",
        padding: "10px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "12px",
        flexShrink: 0,
        borderRadius: "60px 60px 60px 4px",
        background: "var(--SEIZO-bleu, #00B0FF)",
        cursor: "pointer"
    };


    return (
        <div onClick={onClick} style={{...defaultStyle, ...style}}>
            <div style={{
                width: "20px",
                height: "20.001px",
                flexShrink: 0
            }}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 2.5V17.5007" stroke="white" strokeWidth="2"/>
                    <path d="M2.5 10L17.5 10" stroke="white" strokeWidth="2"/>
                </svg>
            </div>
        </div>
    );
};

export default BtnPlus;
